import { get, post, put } from './apiService';

const matchService = {
  getMatches: async () => {
    try {
      return await get('admin/getmatches', { withCredentials: false });
    } catch (err) {
      throw new Error(err.message || 'Failed to fetch matches');
    }
  },
  getMatch: async (id) => {
    try {
      return await get(`admin/GetMatch/${id}`, { withCredentials: false });
    } catch (err) {
      throw new Error(err.message || 'Failed to fetch match');
    }
  },
  createMatch: async (data) => {
    try {
      return await post('admin/creatematch', data, { withCredentials: false});
    } catch (err) {
      throw new Error(err.message || 'Failed to create match');
    }
  },
  updateMatch: async (data) => {
    try {
      return await put('admin/updatematch', data, { withCredentials: false});
    } catch (err) {
      throw new Error(err.message || 'Failed to update match');
    }
  },
  startMatch: async (id) => {
    try {
      return await post(`admin/startmatch/${id}`, {}, { withCredentials: false});
    } catch (err) {
      throw new Error(err.message || 'Failed to start match');
    }
  },
  endMatch: async (id) => {
    try {
      return await post(`admin/endmatch/${id}`, {}, { withCredentials: false});
    } catch (err) {
      throw new Error(err.message || 'Failed to end match');
    }
  },
  addMatchResult: async (data) => {
    try {
      return await post('admin/addmatchresult', data, { withCredentials: false});
    } catch (err) {
      throw new Error(err.message || 'Failed to add match result');
    }
  },
  uploadAutoResultJson: async (matchId, file) => {
    try {
      const formData = new FormData();
      formData.append('jsonFile', file);
      // Endpoint provided by backend: addautomaticallyMatchResult/{matchId}/upload-result-json
      return await post(`admin/addautomaticallyMatchResult/${matchId}/upload-result-json`, formData, {
        withCredentials: false,
        headers: { 'Content-Type': 'multipart/form-data' }
      });
    } catch (err) {
      throw new Error(err.message || 'Failed to upload match result JSON');
    }
  },
};

export default matchService;
